import { TLShapeId, useEditor } from '@tldraw/tldraw'
import { useLayoutEffect } from 'react'
import { deleteIfOutsideFrame } from '../helpers'
import { uniq } from 'lodash'

export const FrameOverflowHandlers = () => {
  const editor = useEditor()

  useLayoutEffect(() => {
    editor.store.listen((entry) => {
      if ('instance_page_state:page:page' in entry.changes.updated && editor.root.getPath() === 'root.select.idle') {
        const selectedShapeIds = uniq(
          (
            entry.changes.updated['instance_page_state:page:page'] as Array<{
              selectedShapeIds: Array<string>
            }>
          ).flatMap((update) => update.selectedShapeIds),
        )
        selectedShapeIds.forEach((id: string) => {
          const shape = editor.getShape(id as TLShapeId)
          if (!shape) return
          deleteIfOutsideFrame(editor, shape)
        })
      }
    })
  }, [editor])

  return null
}
